
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/store/[cartUrl]/corporate-login",
      function () {
        return require("private-next-pages/store/[cartUrl]/corporate-login/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/store/[cartUrl]/corporate-login"])
      });
    }
  